module.exports = {
      id: "play-fill-icon-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#play-fill-icon",
      toString: function () {
        return this.url;
      }
    }